module.exports = __webpack_public_path__ + "img/DateTime.8709fc39.svg";